function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { AppContext } from 'context';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as shapes from '../../shapes';
import messages from '../../messages';
import ActivePatients from '../../partials/PatientsList/ActivePatients';
import SearchPatients from '../../partials/SearchPatients';
import styles from './MergePatientModal.pcss';
var _React_PureComponent;
class ChoosePatient extends (_React_PureComponent = React.PureComponent) {
    onSubmit(evt, clinicPatient) {
        evt.preventDefault();
        const { activePatient, sharingRequest, activeClinicMembership } = this.props;
        this.props.onSubmit(activePatient, clinicPatient, sharingRequest, activeClinicMembership);
        this.props.onSetComponent('Merging');
    }
    renderPatientsBody() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.patients__searchContainer,
                    children: /*#__PURE__*/ _jsx(SearchPatients, {
                        forId: "enrollingList",
                        activeClinicMembership: this.props.activeClinicMembership
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.patients__listContainer,
                    children: /*#__PURE__*/ _jsx(ActivePatients, {
                        id: "enrollingList",
                        omitPatient: this.props.activePatient,
                        activeClinicMembership: this.props.activeClinicMembership,
                        styleModifier: "halfSpace",
                        isWithoutLoad: true,
                        onClick: (evt, patient)=>this.onSubmit(evt, patient)
                    })
                })
            ]
        });
    }
    renderPatients() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.patients,
            children: this.renderPatientsBody()
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "modal__info",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.choosePatientAndBind))
                }),
                this.renderPatients()
            ]
        });
    }
    constructor(props){
        super(props);
        props.onSetHeaderMessage(messages.headers.choosePatient);
    }
}
_define_property(ChoosePatient, "contextType", AppContext);
_define_property(ChoosePatient, "propTypes", {
    // Explicit props
    activePatient: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        dateOfBirth: PropTypes.string
    }),
    clinicPatient: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        dateOfBirth: PropTypes.string
    }),
    sharingRequest: shapes.sharingRequest,
    // Explicit actions
    onSetComponent: PropTypes.func,
    onSetHeaderMessage: PropTypes.func,
    onSetClinicPatient: PropTypes.func,
    // Implicit props
    activeClinicMembership: Account.shapes.clinicMembership,
    formValues: PropTypes.object,
    // Implicit actions
    onSubmit: PropTypes.func
});
const mapStateToProps = (state)=>({
        activeClinicMembership: Account.selectors.activeClinicMembership(state),
        formValues: App.selectors.formSelector(constants.MERGE_PATIENT_FORM)(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSubmit: (activePatient, clinicPatient, sharingRequest, clinicMembership)=>dispatch(actions.mergePatient(activePatient, clinicPatient, sharingRequest, clinicMembership))
    });
const ConnectedChoosePatient = connect(mapStateToProps, mapDispatchToProps)(ChoosePatient);
export default ConnectedChoosePatient;
